// Mirrors Organization::TRIAL_PERIOD in app/models/organization.rb (currently 7.days).
// If that value changes, update this constant to match.
export const TRIAL_DURATION_DAYS = 7;

export const APPLICATION_RESPONSE_SLA_DAYS = 5;

// The one wording for how long a subscription application takes to review
// (Mischa, 2026-09-17). It was written five different ways across the apply page,
// the application-submitted modal, the already-requested screen, the pending
// explainer and the pending sidebar card — including "in 1–5 days", which drops
// "business" and so promises something shorter. Every surface reads this now.
export const APPLICATION_REVIEW_WINDOW = `1–5 business days`;

// Where customers are told to write about billing and access.
export const SUPPORT_EMAIL = 'support@civiclens.dev';

// Kept in sync with User::PERSONAL_EMAIL_DOMAINS in app/models/user.rb
export const PERSONAL_EMAIL_DOMAINS = ['gmail.com', 'yahoo.com', 'outlook.com', 'hotmail.com', 'protonmail.com'];

// Kept in sync with Organization::ORG_TYPES in app/models/organization.rb
export const ORG_TYPES = ['Newsroom', 'Non-profit', 'Academic', 'Political', 'Independent', 'Commercial', 'Other'];

// Display-only price map. Prices are Stripe-managed, not stored in our DB.
// Keys mirror Api::V2::OrganizationsController::SUBSCRIPTION_PLANS (lowercase),
// which is what organization.selected_plan stores.
export const PLAN_PRICES = {
  basic: '$100',
  standard: '$500',
  advanced: '$1,000',
  pro: '$2,500',
};

// Per-plan feature lists shown in the plan-summary card on the payment and apply
// screens. Source: subscription-flow v2 design (Prototype C_A_primer_v2.html).
export const PLAN_FEATURES = {
  basic: [
    'Full monitoring access',
    'Unlimited searches with filters',
    'Up to 5 team members',
    '1 hour onboarding session',
  ],
  standard: [
    'Full monitoring access',
    '500 channel tracking credits / year',
    'Up to 10 team members',
    '50 CSV exports / month',
    'Unlimited SMS tiplines',
  ],
  advanced: [
    'Full monitoring access',
    '1,000 channel tracking credits / year',
    'Up to 25 team members',
    '500 CSV exports / month',
    'API access · 500 req / hr',
  ],
  pro: [
    'Full monitoring access',
    '10,000 channel tracking credits / year',
    'Up to 50 team members',
    'Unlimited CSV exports',
    'API access · 5,000 req / hr',
  ],
};

// Title-cases a plan key for display (e.g. 'advanced' -> 'Advanced').
export const planLabel = (plan) =>
  plan ? plan.charAt(0).toUpperCase() + plan.slice(1) : '';
